import React from "react";

export default function Spinner({
  size = 40,
  color = "black",
  speed = 0.9,
  stroke = 5,
}) {
  const maskSize = `calc(${size}px / 2 - ${stroke}px)`;

  return (
    <>
      <style>
        {`
          .spinner {
            position: relative;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            height: var(--uib-size);
            width: var(--uib-size);

            -webkit-mask: radial-gradient(
              circle var(--mask-size),
              transparent 99%,
              #000 100%
            );
            mask: radial-gradient(
              circle var(--mask-size),
              transparent 99%,
              #000 100%
            );

            background-image: conic-gradient(
              transparent 25%,
              var(--uib-color)
            );

            animation: spin var(--uib-speed) linear infinite;
            border-radius: 50%;
          }

          @keyframes spin {
            0% {
              transform: rotate(0deg);
            }
            100% {
              transform: rotate(360deg);
            }
          }
        `}
      </style>

      <div
        className="spinner"
        style={{
          "--uib-size": `${size}px`,
          "--uib-color": color,
          "--uib-speed": `${speed}s`,
          "--uib-stroke": `${stroke}px`,
          "--mask-size": maskSize,
        }}
      />
    </>
  );
}
